module.exports = __webpack_public_path__ + "static/media/promo_2_pic_1.cd01de00.svg";